import { Card, Image } from "antd";
import styled from "styled-components";
import { useState } from "react";

interface Props {
  name?: string | null;
  pictureLink?: string | null;
}

// Styled components
const KillerCard = styled(Card)<{ $height: number }>`
  width: 200px;
  height: ${(p) => p.$height}px;
  overflow: hidden;
  border-radius: 0;
  border-bottom: 32px solid white;
  .ant-card-body {
    padding: 12px;
  }
  .ant-image,
  .ant-image-img {
    width: 100% !important;
    height: 100% !important;
    object-fit: cover;
    object-position: center top;
    filter: grayscale(100%);
  }
`;

const KillerImage = styled(Image)`
  display: block;
  width: 100%;
  height: 100%;
`;

const MAX_HEIGHT = 240;

export function SerialKillerPicture({ name, pictureLink }: Props) {
  const [height, setHeight] = useState(MAX_HEIGHT);

  if (!pictureLink) return null;

  const handleLoad = (e: React.SyntheticEvent<HTMLImageElement>) => {
    const img = e.currentTarget;
    // Scale naturalHeight proportionally to the fixed 200px width
    const scaled = Math.round((img.naturalHeight / img.naturalWidth) * 200);
    setHeight(Math.min(scaled, MAX_HEIGHT));
  };

  return (
    <KillerCard $height={height}>
      <KillerImage
        src={pictureLink}
        alt={name ?? "picture"}
        preview={false}
        onLoad={handleLoad}
      />
    </KillerCard>
  );
}
